import { Area } from 'react-easy-crop';

export const createImage = (url: string): Promise<HTMLImageElement> =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.addEventListener('load', () => resolve(image));
		image.addEventListener('error', (error) => reject(error));
		image.src = url;
	});


/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */
export const getCroppedImg = async ({
										imageSrc,
										pixelCrop,
										maxWidth
									}: {
	imageSrc: string;
	pixelCrop: Area;
	maxWidth?: number; // Make maxWidth optional
}): Promise<{ file: string; fileURL: string }> => {
	const image = await createImage(imageSrc);
	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	if (!ctx) {
		throw new Error('No 2d context');
	}

	// Set initial canvas size to match the cropped area
	let width = pixelCrop.width;
	let height = pixelCrop.height;

	// Apply maxWidth constraint if provided
	if (maxWidth && width > maxWidth) {
		const aspectRatio = width / height;
		width = maxWidth;
		height = width / aspectRatio;
	}

	canvas.width = width;
	canvas.height = height;

	// IMPORTANT: Clear the canvas with transparent background
	ctx.clearRect(0, 0, canvas.width, canvas.height);

	// Draw the cropped image with resizing if needed
	ctx.drawImage(
		image,
		pixelCrop.x,
		pixelCrop.y,
		pixelCrop.width,
		pixelCrop.height,
		0,
		0,
		width,
		height
	);

	// Convert canvas to blob
	return new Promise((resolve) => {
		// Use PNG format to preserve transparency
		canvas.toBlob((blob) => {
			if (!blob) {
				console.error('Canvas is empty');
				return;
			}

			const fileURL = window.URL.createObjectURL(blob);

			// Convert blob to base64
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = (): void => {
				const base64data = reader.result as string;
				resolve({
					file: base64data,
					fileURL
				});
			};
		}, 'image/png'); // Explicitly use PNG format for transparency
	});
};
